const Metric = ({ title, description, icon = null, titleSize='h4', className='', children }) => {
    return (
        <div className={`bg-white p-4 flex justify-between items-center gap-4 ${className}`}>
            <div className="text-purple">
                <div className="flex gap-4 items-center">
                    {icon}
                    <span className={titleSize}>{title}</span>
                </div>
                {description && <span className='text-sm'>{description}</span>}
            </div>
            {children}
        </div>
    );
};

export default Metric;